<template>
    <CreditCardItem
        v-for="(creditCard, k) in creditCardList"
        :creditCard="creditCard"
        :key="k"
        @onSelectCreditCard="onSelectCreditCard(k)"
        @setDefaultCard="setDefaultCard(k)"
        @onDeleteCard="onDeleteCard($event)"
    ></CreditCardItem>
    <!-- #region use with /card page -->
    <div v-if="isLoaded && !isHavItem && $route.path == '/card'" class="mt-24 lg:mt-12">
        <img class="mb-3 mx-auto lg:w-14" src="@/assets/icon/ic-credit-card.svg">
        <div class="mb-4 text-14 lg:text-16 text-center text-a-brown-9f8273">{{lbl.creditCard.card_notfound}}</div>
    </div>
    <!-- #end region use with /card page -->
</template>
<script>
//helper
import CacheHelper from '@/helper/CacheHelper'
import { CacheKey } from '@/helper/StaticValue'
//component
import CreditCardItem from './CreditCardItem.vue'
//service
import BKCredit from "../service/BkCardit.js";
//mixin
import LocaleMixin from '@/mixin/LocaleMixin';
import ModalMixin from "@/mixin/ModalMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import AuthStatusMixin from "@/mixin/AuthStatusMixin";

export default {
    name: "CreditCardList",
    mixins: [LocaleMixin, ModalMixin, ErrorApiMixin,AuthStatusMixin],

    components: {
        CreditCardItem
    },
    data: function() {
        return {
            creditCardList: [],
            isLoaded: false,
            isHavItem: false,
        };
    },
    mounted: function() {
        if (this.isGuestAccountRegistered) { 
            this.getAddressListCache();
        } else {
            this.getAddressList();
        }
    },
    methods: {
        getAddressListCache: function() { 
            let cache = new CacheHelper('session');
            let dataCache = cache.getCache(CacheKey.setCredit);
            if (dataCache) {
                this.creditCardList = dataCache;
                this.isLoaded = true;
                this.isHavItem = this.creditCardList.length > 0;
            }
        },
        getAddressList: function() {
            BKCredit.apiGetCreditCard().subscribe({
                next: (data) => {
                    console.log(data);
                    this.creditCardList = data;
                    // #region use with /card page (set default card checkbox)
                    if(this.$route.path == '/card'){
                        for (let creditCard of this.creditCardList){
                            if(creditCard.isDefault)
                                creditCard.isSelect = true;
                        }
                    }
                    // #end region use with /card page (set default card checkbox)
                    this.isLoaded = true;
                    this.isHavItem = this.creditCardList.length > 0;
                },
                error: (err) => {
                    this.isLoaded = true;
                    this.isHavItem = false;
                    this.errorApi(err);
                },
            });
        },
        onSelectCreditCard: function(index) {
            let isSelect = this.creditCardList[index].isSelect;
            if (isSelect) {
                this.creditCardList[index].isSelect = false;
            } else {
                for (let creditCard of this.creditCardList){
                    creditCard.isSelect = false;
                }
                this.creditCardList[index].isSelect = true;
            }
        },
        getSelectCreditCard: function() {
            for (let creditCard of this.creditCardList){
                if (creditCard.isSelect) {
                    return creditCard;
                }
            }
            return null;
        },
        // #region use with /card page (set default card)
        setDefaultCard: async function(index) {
            let isSelect = this.creditCardList[index].isSelect;
            if (isSelect) {
                this.creditCardList[index].isSelect = false;
            } else {
                for (let creditCard of this.creditCardList){
                    creditCard.isSelect = false;
                }
                this.creditCardList[index].isSelect = true;
            }
            await this.apiSetDefaultCreditCard(this.creditCardList[index].id);
        },
        onDeleteCard: function(card){
            this.modal.confirmModal.clearModal()
                    .setMsg(this.lbl.creditCard.modal_del_msg)
                    .setBtnOk(this.lbl.creditCard.confirm_del_btn)
                    .show()
            this.modal.confirmModal.onClickOk(async () => {
                await this.apiDeleteCreditCard(card.id);
            });
        },
        apiDeleteCreditCard: function(cardId) {
            return new Promise((resolve) => {
                this.modal.loadingModal.show();
                BKCredit.apiDeleteCreditCard(cardId).subscribe({
                    next: (data) => {
                        console.log(data);
                        this.modal.loadingModal.hide();
                        this.getAddressList();
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        this.modal.loadingModal.hide();
                        this.errorApi(err);
                    },
                });
            });
        },
        apiSetDefaultCreditCard: function(cardId) {
            return new Promise((resolve) => {
                this.modal.loadingModal.show();
                BKCredit.apiSetDefaultCreditCard(cardId).subscribe({
                    next: (data) => {
                        console.log(data);
                        this.modal.loadingModal.hide();
                        this.getAddressList();
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        this.modal.loadingModal.hide();
                        this.errorApi(err);
                    },
                });
            });
        },
        // #end region use with /card page (set default card)
    },
}
</script>
